import {IProfileAddress} from '../../../../../services/hookService/getOrderDetails/types';
import InfoRow from '../../../../shopping-basket/ItemCard/InfoRow';

interface IProps {
  createdDate: string | null;
  supplyDate: string | null;
  totalOrderPrice: number;
  address: IProfileAddress | null;
}

const OrderInformation = ({
  createdDate,
  supplyDate,
  totalOrderPrice,
  address,
}: Partial<IProps>) => {
  const isDeliveryInPerson = !Boolean(address?.guid);

  return (
    <div className="space-y-2">
      <span className="text-sm font-medium text-zinc-500">اطلاعات سفارش</span>

      <div className="p-3 space-y-2 bg-zinc-100 rounded-xl text-md">
        {
          <InfoRow
            icon="icon-nameCalendar"
            label="تاریخ ثبت"
            value={createdDate ?? 'مشخص نشده'}
          />
        }
        <InfoRow
          icon="icon-nameCalendar"
          label="تاریخ تامین"
          value={supplyDate ?? 'مشخص نشده'}
        />
        <InfoRow
          icon="icon-namemoney"
          label="مبلغ کل سفارش"
          value={
            totalOrderPrice
              ? totalOrderPrice.toLocaleString() + ' تومان '
              : 'مشخص نشده'
          }
        />
        <InfoRow
          icon="icon-nameDelivery-Boxes-2"
          label="نوع تحویل"
          value={isDeliveryInPerson ? 'تحویل حضوری' : 'ارسال فروشنده'}
        />
      </div>
    </div>
  );
};

export default OrderInformation;
